import React, { useState, useContext } from "react";
import { Link } from "react-router-dom";
import { MdTouchApp } from "react-icons/md";
import { FaBars, FaTimes } from "react-icons/fa";
import Button from "./Button";
import "./Navbar.css";
import { IconContext } from "react-icons/lib";
import { ThemeContext } from "./ThemeStore";

function Navbar() {
  const [click, setClick] = useState(false);
  const [button, setButton] = useState(true);
  const { theme, switchTheme } = useContext(ThemeContext);

  const handleClick = () => setClick(!click);
  const closeMobileMenu = () => setClick(false);

  const showButton = () => {
    if (window.innerWidth <= 960) {
      setButton(false);
    } else {
      setButton(true);
    }
  };

  const toggleTheme = (props) => {
    closeMobileMenu();
    switchTheme(props);
  };

  window.addEventListener("resize", showButton);

  return (
    <>
      <IconContext.Provider value={{ color: "#fff" }}>
        <div className="navbar">
          <div className="navbar-container container">
            <Link to="/" className="navbar-logo" onClick={closeMobileMenu}>
              KUNWAR
            </Link>
            <div className="menu-icon" onClick={handleClick}>
              {click ? <FaTimes /> : <FaBars />}
            </div>
            <ul className={click ? "nav-menu active" : "nav-menu"}>
              <li className="nav-item">
                <Link to="/" className="nav-links" onClick={closeMobileMenu}>
                  Home
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  to="/utilities"
                  className="nav-links"
                  onClick={closeMobileMenu}
                >
                  Utilities
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  to="/about"
                  className="nav-links"
                  onClick={closeMobileMenu}
                >
                  About
                </Link>
              </li>
              <li className="nav-btn">
                {button ? (
                  <Link className="btn-link">
                    {theme === "light" ? (
                      <Button
                        buttonStyle="btn--outline"
                        onClick={() => toggleTheme("dark")}
                      >
                        Switch on Dark Mode
                      </Button>
                    ) : (
                      <Button
                        buttonStyle="btn--outline"
                        onClick={() => toggleTheme("light")}
                      >
                        Switch off Dark Mode
                      </Button>
                    )}
                  </Link>
                ) : (
                  <Link className="btn-link">
                    {theme === "light" ? (
                      <Button
                        buttonStyle="btn--outline"
                        onClick={() => toggleTheme("dark")}
                      >
                        Switch on Dark Mode
                      </Button>
                    ) : (
                      <Button
                        buttonStyle="btn--outline"
                        onClick={() => toggleTheme("light")}
                      >
                        Switch off Dark Mode
                      </Button>
                    )}
                  </Link>
                )}
              </li>
            </ul>
          </div>
        </div>
      </IconContext.Provider>
    </>
  );
}

export default Navbar;
